import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { PkgShippingMethod, UserPkg } from '../types/UserPkg'
import { updateUserPkgShippingMethod } from '../userPkgService'

export const useUpdateUserPkgShippingMethod = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateUserPkgShippingMethod,
    onMutate: ({ pkgId, shippingMethod }) => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      const oldPkgs = queryClient.getQueryData([QUERY_KEYS.USER_PACKAGES])
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(pkg => (pkg.id === pkgId ? { ...pkg, shippingMethod: shippingMethod as PkgShippingMethod } : pkg))
      )
      return { oldPkgs }
    },
    onError: (_error, _, context) => {
      if (context?.oldPkgs) {
        queryClient.setQueryData([QUERY_KEYS.USER_PACKAGES], context.oldPkgs)
      }
    },
  })
}
